<template>
    <loaderApp v-if="loader" />
    <template v-else-if="(myActivePlan && myActivePlan.length == 0) && (myPastPlans && myPastPlans.length == 0 && !setSearch)">
        <mainBanner page="myPlan"/>
    </template>
    <template v-else>       
        <CanselOrderScreen v-if="canсelOrderScreen" :calselOrderID="calselOrderID" :offers="offers" :bonusSettings="bonusSettings" @update:visible="canсelOrderScreen = $event"/>
        <template v-else>
            <div class="my-plan-container" v-if="!setSearch && myActivePlan.length > 0">  
                <div class="block-page-title" :class="{'empty': myActivePlan.length == 0 }">
                    <h2 v-if="myActivePlan && myActivePlan.length > 0">My plan - Active</h2>
                    <h2 v-else>No Active Plan</h2>
                </div>
            </div> 
            <template v-if="myActivePlan && myActivePlan.length > 0">
                <div v-for="planActive in myActivePlan" :key="planActive.order_id" class="mb-12">
                    <div class="my-plan-container-bg">  
                        <div class="my-plan-container">  
                            <div class="block-rewards">
                                <h3>Details</h3>
                            </div>
                            <div class="order-details">
                                <ul>
                                    <li><strong>Sub no: </strong> <span>#{{ planActive.number }}</span></li>
                                    <li><strong>Status:</strong> <span> {{ planActive.status }}</span></li>
                                    <li><strong>Price:</strong> <span class="price">€{{ planActive.total }}</span></li>
                                </ul>
                            </div>  
                            <div class="d-flex block-delivery-date">
                                <div><strong>Next delivery date:</strong></div>
                                <div v-if="planActive.delivery_date">{{ planActive.delivery_date }} - <a :href="planActive.download" class="btn-add-calendar" download>Add to my calendar</a></div>
                                <div v-else>-</div>
                            </div>  
                            <div class="row-btn row-btn-delivery">
                                <a class="btn btn-edit-delivery" @click.prevent="changeDeliveryDate( planActive )">Change next delivery date 
                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                        <path d="M5.25405 12.4941C5.25405 12.4941 5.25205 12.5001 5.25005 12.5031C5.25005 12.5011 5.24805 12.5001 5.24805 12.4981L5.25405 12.4941Z" fill="#685BC7"/>
                                        <path d="M13.4669 19.4627C10.7579 19.6507 8.04789 19.8337 5.33589 19.9727C4.22589 20.0297 3.03489 20.0837 2.19489 19.2087C1.80189 18.7977 1.48089 18.0997 1.50089 17.5467C1.61489 14.4647 1.87289 11.3887 2.02189 8.3087C2.10589 6.5857 2.00689 4.8527 2.12189 3.1327C2.19689 2.0107 2.47989 1.8867 3.39389 2.4697C4.23289 3.0047 4.37589 2.1187 4.35489 1.8927C4.27489 1.0587 4.40289 0.333703 5.33789 0.420703C6.14789 0.496703 6.74589 1.1007 6.69589 2.0677C6.69289 2.1267 6.75289 2.1877 6.77689 2.2357H14.5619C14.5619 1.6537 14.4609 1.0257 14.6099 0.462703C14.6719 0.228703 15.2579 0.0287029 15.6199 0.0027029C16.3039 -0.0472971 16.9309 0.996703 16.9289 2.1087C17.1999 2.1217 17.4789 2.1697 17.7469 2.1367C18.0239 2.1037 18.2909 1.9907 18.7859 1.8497C18.7859 2.5097 18.7809 3.0627 18.7859 3.6157C18.8169 6.7607 18.8029 9.9067 18.9029 13.0487C18.9579 14.7667 19.2099 16.4777 19.3659 18.1927C19.4749 19.3967 19.4469 19.3247 18.2429 19.1937C17.2329 19.0837 13.9669 19.4287 13.4659 19.4637L13.4669 19.4627ZM17.2999 7.8787C14.7499 7.8787 12.2659 7.8787 9.78189 7.8787C7.99689 7.8787 6.21089 7.8457 4.42789 7.9057C4.18689 7.9137 3.78389 8.3627 3.76189 8.6317C3.69989 9.3767 3.87189 10.1407 3.82289 10.8887C3.70689 12.6487 3.49989 14.4017 3.36089 16.1597C3.19689 18.2367 3.38489 18.3397 5.40089 18.1577C8.19389 17.9067 10.9989 17.7797 13.7989 17.5977C14.8919 17.5267 15.9839 17.4477 17.2999 17.3577V7.8787ZM17.1529 3.2887L17.2129 3.3307L17.2219 3.2647L17.1529 3.2887ZM7.04489 7.8967C7.02689 7.8737 7.00889 7.8507 6.99189 7.8277C6.96989 7.8467 6.93189 7.8627 6.92889 7.8837C6.92689 7.9047 6.95989 7.9297 6.97789 7.9527C6.99989 7.9337 7.02289 7.9157 7.04489 7.8967ZM8.97489 11.0597C8.98389 11.2337 9.02189 11.4127 8.99789 11.5827C8.77489 13.1247 8.66289 13.1987 7.06289 12.9127C6.86589 12.8777 6.66589 12.8587 6.46789 12.8317C5.35189 12.6807 5.15789 12.4697 5.10789 11.3647C5.09989 11.1897 5.05289 11.0127 5.07089 10.8407C5.12289 10.3477 5.06889 9.5117 5.28889 9.4287C5.99989 9.1617 6.81489 9.1667 7.59189 9.0837C7.69189 9.0727 7.85789 9.2347 7.90189 9.1997C8.65089 8.6067 8.70289 9.4657 8.84089 9.7417C9.02789 10.1157 8.97489 10.6107 9.02489 11.0527L8.97689 11.0577L8.97489 11.0597Z" />
                                    </svg>
                                </a>
                            </div>
                            <!-- <div class="block-rewards">
                                <h3>What’s included</h3>
                            </div>   -->
                            <!-- <div class="order-details-more">
                                <ul> -->
                                    <!-- <li><strong>Plan:</strong> <span> {{  planActive.plan ? planActive.plan : ' - ' }}</span></li>
                                    <li><strong>Customise:</strong> <span> {{ planActive.customise ? planActive.customise : ' - ' }}</span></li>
                                    <li><strong>Protein:</strong> <span> {{ planActive.protein ? planActive.protein : ' - ' }}</span></li>
                                    <li class="no-days"><strong>No of days:</strong> <span> {{ getDaysView(planActive) }}</span></li> -->
                                    <!-- <li class="no-meals"><strong>No of meals:</strong> <span> {{ countDishas( planActive, 1 ).M }} main meals, {{  countDishas(planActive, 1 ).B }} breakfasts, {{ countDishas(planActive, 1 ).S }} snacks</span></li>
                                    <li class="summary" v-if="planActive.summary"><strong>Summary:</strong>
                                        <span>
                                            {{ planActive.summary }}
                                        </span>
                                    </li>
                                </ul>
                            </div>    -->
                            <!-- <div class="row-btn">
                                <div class="btn btn-edit-meals" @click="editLastPlan( planActive )">Edit my meals <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                    <path d="M16.052 20.508C14.677 19.157 12.133 16.359 10.792 14.974C10.17 14.331 9.55899 13.676 8.95999 13.012C8.54799 12.556 8.16899 12.379 7.45799 12.479C4.30899 12.923 2.08699 11.65 0.882992 8.99303C0.241992 7.57603 0.470992 6.22003 1.08799 4.91003C1.38899 4.27003 1.98799 4.59403 2.36999 4.87803C2.86599 5.24603 3.36099 5.67703 3.69999 6.18403C4.31299 7.10303 4.87299 6.99003 5.53599 6.29103C5.73799 6.07903 5.98899 5.91403 6.27399 5.68203C5.64599 4.88803 4.97499 4.16403 4.45899 3.34203C4.13499 2.82503 3.92199 2.16303 3.91999 1.56503C3.91999 1.38803 4.79199 1.10203 5.28399 1.04603C7.95899 0.739033 9.86799 1.90703 10.836 4.49403C11.178 5.40803 11.271 6.41303 11.548 7.35603C11.662 7.74603 11.898 8.14703 12.188 8.43003C13.676 9.88303 16.432 12.68 17.913 14.141C18.666 14.884 19.343 15.708 20.019 16.524C20.498 17.102 20.42 18.387 19.813 18.845C19.128 19.361 18.503 19.897 17.686 20.704C17.348 21.038 16.653 21.094 16.053 20.505L16.052 20.508Z"/>
                                    </svg>
                                </div>
                            </div> 
                            <div class="row-btn-cancel mt-4">
                                <div class="btn-cancel" @click="openScreenCanсelOrder( planActive.order_id )">Cancel</div>
                            </div>  -->
                        </div>
                    </div>            
                    <myMeals 
                        :editPlan="planActive"
                        :mainProductsAll="mainProductsAll" 
                        :breakfastProductsAll="breakfastProductsAll"
                        :snacksProductsAll="snacksProductsAll"
                    />
                    <div class="row-btn">
                        <div class="btn btn-edit-meals" @click="editLastPlan( planActive )">Edit my meals <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                            <path d="M16.052 20.508C14.677 19.157 12.133 16.359 10.792 14.974C10.17 14.331 9.55899 13.676 8.95999 13.012C8.54799 12.556 8.16899 12.379 7.45799 12.479C4.30899 12.923 2.08699 11.65 0.882992 8.99303C0.241992 7.57603 0.470992 6.22003 1.08799 4.91003C1.38899 4.27003 1.98799 4.59403 2.36999 4.87803C2.86599 5.24603 3.36099 5.67703 3.69999 6.18403C4.31299 7.10303 4.87299 6.99003 5.53599 6.29103C5.73799 6.07903 5.98899 5.91403 6.27399 5.68203C5.64599 4.88803 4.97499 4.16403 4.45899 3.34203C4.13499 2.82503 3.92199 2.16303 3.91999 1.56503C3.91999 1.38803 4.79199 1.10203 5.28399 1.04603C7.95899 0.739033 9.86799 1.90703 10.836 4.49403C11.178 5.40803 11.271 6.41303 11.548 7.35603C11.662 7.74603 11.898 8.14703 12.188 8.43003C13.676 9.88303 16.432 12.68 17.913 14.141C18.666 14.884 19.343 15.708 20.019 16.524C20.498 17.102 20.42 18.387 19.813 18.845C19.128 19.361 18.503 19.897 17.686 20.704C17.348 21.038 16.653 21.094 16.053 20.505L16.052 20.508Z"/>
                            </svg>
                        </div>
                    </div>
                    <div class="row-btn-cancel mt-4">
                        <div class="btn-cancel" @click="openScreenCanсelOrder(planActive.order_id)">Cancel</div>
                    </div>
                </div>
            </template>    
            <div class="block-orders-search-bg" v-if="setSearch"> 
                <div class="my-plan-container"> 
                    <div class="block-orders-search">
                        <h3>Past orders</h3>
                        <div class="orders-search">
                            <p>Search</p>
                            <div class="form-search">
                                <v-text-field 
                                    type="text" 
                                    v-model="search"
                                    @keyup.enter="viewSearch"
                                ></v-text-field>
                                <v-btn type="submit" @click="viewSearch">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                        <path d="M4.07436 16.8003C2.58276 16.1175 2.32236 14.5563 1.72836 13.3035C0.361561 10.4199 1.01676 7.49429 2.34276 4.84349C2.97396 3.58109 4.31676 2.54549 5.55396 1.74269C8.43276 -0.12571 11.5168 0.0710894 14.6056 1.31669C15.1876 1.55189 15.8044 1.70309 16.4092 1.87829C17.6572 2.24069 18.424 3.10709 18.6964 4.32029C19.3396 7.19069 19.36 10.0143 17.7076 12.6255C17.644 12.7263 17.6452 12.8667 17.6476 12.8583C19.3168 14.3895 20.9572 15.8283 22.516 17.3499C23.3404 18.1551 24.0484 19.0875 24.754 20.0031C24.9268 20.2275 25.0468 20.7627 24.9172 20.9055C24.1216 21.7815 23.368 22.8075 22.3672 23.3535C21.3412 23.9127 20.4328 23.0595 19.7128 22.2735C18.2524 20.6775 16.6852 19.1595 15.3916 17.4387C14.6932 16.5087 14.0104 16.5759 13.3276 16.9899C10.1644 18.9015 7.09836 18.7395 4.05156 16.7691C4.11156 16.7643 4.17276 16.7607 4.23276 16.7559C4.20996 16.7127 4.18836 16.6695 4.16556 16.6251C4.13556 16.6827 4.10556 16.7415 4.07556 16.7991L4.07436 16.8003ZM11.7604 4.08749C11.7496 4.09949 11.7388 4.11149 11.7292 4.12229C11.746 4.09589 11.7628 4.07069 11.7796 4.04429C8.65116 4.92149 6.19116 6.47669 5.32356 9.90749C4.88196 11.6535 6.26076 13.6971 8.04276 13.8399C9.79836 13.9803 11.2324 13.3107 12.7312 12.5631C15.5428 11.1603 16.288 8.81789 14.6428 6.10589L14.6824 6.08069C13.8724 5.17589 13.1596 4.12949 11.7604 4.08629V4.08749ZM19.798 21.4143C19.7728 21.3819 19.7428 21.3207 19.7236 21.3231C19.6492 21.3363 19.5772 21.3699 19.5052 21.3951C19.5328 21.4251 19.5628 21.4827 19.5856 21.4803C19.6576 21.4707 19.7272 21.4383 19.798 21.4143ZM2.61756 4.72109L2.56836 4.80749L2.65356 4.81349L2.61756 4.72109ZM15.07 1.89029L14.9872 1.83989L14.9812 1.92989L15.07 1.89029Z"/>
                                    </svg>
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block-orders-res-bg wrap-plan-edit" v-if="myPastPlans.length == 0 && search.length > 0"> 
                <div class="my-plan-container">   
                    <div class="block-orders-res">
                        <div class="res-top">
                            Order not found...
                        </div>
                    </div>
                </div>
            </div>
            <div class="block-orders-res-bg wrap-plan-edit" v-if="myPastPlans && myPastPlans.length > 0"> 
                <div class="my-plan-container">   
                    <div class="block-orders-res">
                        <div class="res-top">
                            <div>({{ myPastPlans.length }}) orders</div>
                            <div class="btn btn-filter" @click="showPopup = true">Filter by</div>                    
                        </div>
                        <div class="past-orders">
                            <ul v-if="myPastPlans.length > 0">
                                <template v-for="(plan, i ) in myPastPlans" :key="i">
                                    <li v-if="i < perPage">
                                        <cardOrder 
                                            :data="plan" 
                                            @getOrderdishes="viewOrderdishes = $event" 
                                            @update:visible="showPopupDishes = $event"
                                            :editPlan="viewOrderdishes" 
                                            :mainProductsAll="mainProductsAll"
                                            :breakfastProductsAll="breakfastProductsAll"
                                            :snacksProductsAll="snacksProductsAll"
                                        />
                                    </li>
                                </template>
                            </ul>                           
                        </div>
                    </div>
                    <div class="row-btn" v-if="myPastPlans.length > perPage">
                        <div class="btn btn-edit-delivery" @click="seeMoreOrders">See more past orders 
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                <path d="M10.7712 0.0481788C11.8002 0.150179 12.0582 0.978179 12.0242 1.88218C11.9322 4.30318 11.3972 13.5362 11.3972 15.0612C12.3772 13.8592 13.2972 12.7772 14.1642 11.6552C14.9092 10.6922 15.5692 9.66318 16.3122 8.69818C17.0692 7.71518 17.9752 7.69418 18.9532 8.56918C19.8352 9.35918 19.6002 10.0892 18.9232 10.8962C17.9622 12.0402 17.0942 13.2622 16.1542 14.4242C14.8012 16.0982 13.4552 17.7802 12.0352 19.3962C11.1792 20.3702 9.63815 20.2192 8.58915 18.9992C6.25815 16.2872 3.98715 13.5242 1.75615 10.7322C1.46115 10.3632 1.27815 9.51018 1.49615 9.20818C1.91215 8.63018 2.38515 9.14718 2.80415 9.53118C3.54015 10.2062 4.33815 10.8132 5.10815 11.4462C4.96915 11.4232 4.83415 11.4022 5.07015 11.4382C4.84315 11.5172 4.96615 11.4742 5.09015 11.4312C6.35915 12.5772 7.62815 13.7222 8.95415 14.9202C8.99515 14.7872 9.02315 6.00118 9.00115 1.80018C8.99315 0.275179 9.82015 -0.0458212 10.7722 0.0481788H10.7712Z"/>
                            </svg>
                        </div>
                    </div> 
                </div>            
            </div>
        </template>
    </template>
    <div class="popup-calendar-wrap">
        <mainPopup :visible="showPopupCalender" @update:visible="showPopupCalender = $event" >            
            <calender-app 
                @update:visible="showPopupCalender = $event"
                :order="calseDDOrder"
                />
        </mainPopup>
        <mainPopup :visible="showPopup" @update:visible="showPopup = $event" >
            <div class="sort-wrap">
                <h4>Sort by:</h4>
                <ul>
                    <li>
                        <input type="radio" id="most-recent" value="date-desc" v-model="sortBy" @click="setSortBy('number-desc')">
                        <label for="most-recent">Most Recent</label>
                    </li>
                    <li>
                        <input type="radio" id="oldest" value="date-asc" v-model="sortBy"  @click="setSortBy('number-asc')">
                        <label for="oldest">Oldest</label>
                    </li>
                    <li>
                        <input type="radio" id="price-desc" value="price-desc" v-model="sortBy"  @click="setSortBy('price-desc')">
                        <label for="price-desc">Price DESC</label>
                    </li>
                    <li>
                        <input type="radio" id="price-asc" value="price-asc" v-model="sortBy"  @click="setSortBy('price-asc')">
                        <label for="price-asc">Price ASC</label>
                    </li>                   
                </ul>
            </div>
        </mainPopup>
    </div>    
    <mainPopup :visible="showPopupDishes" @update:visible="showPopupDishes = $event">
        <div class="popup-wrap">
            <div class="popup-wrap-inside">                            
                <myMeals 
                    :editPlan="viewOrderdishes" 
                    :mainProductsAll="mainProductsAll"
                    :breakfastProductsAll="breakfastProductsAll"
                    :snacksProductsAll="snacksProductsAll"
                />
            </div>
        </div>
    </mainPopup>
    <alertApp></alertApp>
</template>

<script>

import { url } from '@/api/api.js'
import Cookies from 'js-cookie';
import myMeals from '@/components/account/myMeals.vue';
import cardOrder from '@/components/cards/cardOrder.vue';
import mainBanner from '@/components/account/mainBanner.vue';
import mainPopup from '@/components/common/mainPopup.vue';
import calenderApp from '@/components/common/calenderApp.vue';
import loaderApp from '@/components/common/loaderApp.vue';
import alertApp from '@/components/common/alertApp.vue';
import CanselOrderScreen from '@/components/canсelOrderScreen.vue';

export default {
    name: 'myPlan',
    components: {
        alertApp,
        loaderApp,
        cardOrder,
        calenderApp,
        mainBanner,
        mainPopup,
        myMeals,
        CanselOrderScreen,      
    },
    data() {
        return {
            search: '',
            filter: '',
            perPage: 12,
            viewDay: 0,
            showPopup: false,
            showPopupCalender: false,
            showPopupDishes: false,
            sortBy: null,
            viewOrderdishes: {},
            nameDays: [
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday',
                'Sunday'
            ],
            canсelOrderScreen: false,
            calseDDOrder:null,
            setSearch: false,
            calselOrderID: null           
        }
    },
    methods: {
        changeDeliveryDate( planActive ){         
            // this.showPopupCalender = true;
            // this.calseDDOrder = planActive;
          
            window.location.href = url + "/account/pause-my-subscription/?sub_id=" + planActive.order_id;
        },
        setSortBy( val ) {
            this.sortBy = val;
            this.showPopup = false;
        },
        openScreenCanсelOrder( ID ) { 
            // this.calselOrderID = ID;
            // this.canсelOrderScreen = true; 
            window.location.href = url + "/account/cancel-my-subscription/?sub_id=" + ID;          
        },
        viewSearch() {   
            this.setSearch = true;         
            this.filter = this.search;

            if(this.search) {
                this.perPage = 12;
            }
        },  
        seeMoreOrders() {
           this.perPage = this.perPage + 12; 
        }, 
        viewActiveDay(i) {
            this.viewDay = i - 1;
        },
        editLastPlan( planActive ) {
            Cookies.remove('plan');
            Cookies.remove('allergies');
            Cookies.remove('allergiesNo');
            Cookies.remove('protein');
            Cookies.remove('days');

            // if ( planActive.plan ) {
            //     this.plans.forEach( plan => {
            //         if ( plan.title == planActive.plan ) { 
            //             Cookies.set('plan', plan.cat_prod_id, { expires: 3600 });                    
            //         } 
                    
            //     });
            // } else {
            //     Cookies.set('plan', this.plans[1].cat_prod_id, { expires: 3600 });
            // }
        
            // if ( planActive.customise ) {
            //      Cookies.set('allergiesNo', 'true', { expires: 3600 });
            // } else if (  planActive.customise == '-' || planActive.customise == '' ) {
            //     Cookies.set('allergiesNo', 'true', { expires: 3600 });  
            //     Cookies.remove('allergies');              
            // } else {
            //     Cookies.set('allergies', planActive.customise, { expires: 3600 });
            //     Cookies.remove('allergiesNo');
            // }

            // if ( planActive.protein ) {
            //     this.proteinsType.forEach((protein) => {
            //         if ( protein.slug === planActive.protein ) {
            //             Cookies.set('protein', protein.slug, { expires: 3600 });
            //         }
            //     });
            // } else {
            //     Cookies.set('protein', 'empty', { expires: 3600 });
            // }

            // let days = planActive.week_days ? planActive.week_days : 1;
            // Cookies.set('days', days, { expires: 3600 });

            Cookies.remove('breakfastCount');
            Cookies.remove('mainCount');
            Cookies.remove('snacksCount');

            // let count = this.countDishas( planActive, days );

            // Cookies.set('breakfastCount', count.B, { expires: 3600 });
            // Cookies.set('mainCount', count.M, { expires: 3600 });
            // Cookies.set('snacksCount', count.S, { expires: 3600 });
            
           // window.location.href = '/edit-order/?order=' + planActive.order_id;
            window.location.href = url + "/account/view-subscription/" + planActive.order_id;
        },
        countDishas( planActive, days ){
     
            return {
                B: Math.ceil(planActive.dishes.filter(item => (item.dish_type == 'breakfast')).length / days),
                M: Math.ceil(planActive.dishes.filter(item => (item.dish_type == 'mains')).length / days),
                S: Math.ceil(planActive.dishes.filter(item => (item.dish_type == 'snacks')).length / days),
            }
        },
        getDaysView( planActive ) {

            if (!planActive.week_days || planActive.week_days == 1) {
                return '1 (Mon)';
            }

            return planActive.week_days ? planActive.week_days
                + ' (Mon-' + this.nameDays[planActive.week_days - 1].substring(0, 3) + ')'
                : ' - ';
        }, 
        viewBlockSearch() {
            this.setSearch = true;
        }
    },
    computed: {
        mainProductsAll(){
            return this.$store.getters.getMainProducts;
        },
        breakfastProductsAll(){
            return this.$store.getters.getBreakfastProducts;
        },
        snacksProductsAll() {
            return this.$store.getters.getSnacksProducts;
        },
        plans() {
            return this.$store.getters.basicPlans;
        },
        proteinsType() {
            return this.$store.getters.proteinsType;
        },
        myActivePlan() {     
            return this.$store.getters.myActivePlan;
        },
        myPastPlans() {  
            let plans = this.$store.getters.myPastPlans;
            if ( plans.length > 0 ) {
                this.viewBlockSearch();
            }

            if ( this.filter.length > 0 ) {
                plans = plans.filter( item => item.number.includes( this.filter ) );
            }

            if ( this.sortBy == 'price-asc' ) {
                plans = plans.sort((a, b) => a.total * 100 > b.total * 100 ? 1 : -1);
            }

            if (this.sortBy == 'price-desc') {
                plans = plans.sort((a, b) => a.total * 100 < b.total * 100 ? 1 : -1);
            }

            if (this.sortBy == 'number-asc') {
                plans = plans.sort((a, b) => a.number > b.number ? 1 : -1);
            }

            if (this.sortBy == 'number-desc') {
                plans = plans.sort((a, b) => a.number < b.number ? 1 : -1);
            }

            return plans;
        },
        countMyOrders() {
            return this.$store.getters.countMyOrders;
        },
        popupOrder() {
            return this.$store.getters.popupOrder;
        },
        loader() {
            return this.$store.getters.loader ?? false;
        },
        bonusSettings() {
            return this.$store.getters.bonusSettings;
        },
        offers() {
            return this.bonusSettings.offers;
        }      
    },
    async beforeMount() {  
        this.$store.dispatch('getMyPlans');     
        this.$store.dispatch('getCountMyOrders');
        this.$store.dispatch('getAllSettings');
        this.$store.dispatch('getBonusSettings');

        setTimeout(() => {
            this.$store.commit('viewLoader', true);
        }, 0);

        this.$store.dispatch('getProducts', {
            mealType: 'mains',
            all: 'true'
        });
        this.$store.dispatch('getProducts', {
            mealType: 'breakfast',
             all: 'true'
        });
        this.$store.dispatch('getProducts', {
            mealType: 'snacks',
            all: 'true'
        });
    },
    watch: {
        mainProductsAll(NewData) {
            this.setMainProducts = NewData;
        },
        breakfastProductsAll(NewData) {
            this.setBreakfastProducts = NewData;
        },
        snacksProductsAll(NewData) {
            this.setSnacksProducts = NewData;
        },
        viewOrderdishes(NewData) {         
            this.viewOrderdishes = NewData;
        }
        // myPastPlans(newData) {

        //     if ( newData.length > 0 ) {
             
        //         this.myPastPlans = newData.filter(
        //             (item) => {
        //                 if ( item && new Date(item.strtotime) > new Date()  != true ) {
                          
        //                     return true;
        //                 }
        //             }
        //         )

                
        //     }
        // }
    }
}
</script >

<style lang="stylus">
@import 'vuetify/dist/vuetify.min.css';
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;700&display=swap');

* {
  box-sizing: border-box;
}

.main-banner {
    justify-content: center!important;
}
.v-btn--icon.v-btn--density-default,                     
.v-btn--elevated {
    box-shadow: none!important;
}

.v-ripple__container,
.v-field__outline,
.v-btn__overlay,
.v-field__overlay,
.v-btn__underlay {
  display: none!important;
}

.my-plan-container {
  max-width: 800px;
  margin: 0 auto;

  .row-btn {
    padding: 2.5rem 0;       
    margin-bottom: 2rem;

  }
}

.order-details ul {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 1rem 0;

    li {
        width: 30%;
        display: flex;
        flex-direction: column;
        font-family: 'Manrope', sans-serif;
        font-size: 14px;
        font-style: normal;
        line-height: normal;

        span {
            text-transform: capitalize;
        }

        .price {
            color: #1D2433;
            font-family: 'Manrope', sans-serif;
            font-size: 24px;
            font-style: normal;
            font-weight: 800;
            line-height: 1;
        }
    }
}
.order-details-more ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;    

    li {
        width: 47%;
        display: flex;
        flex-direction: column;
        font-family: 'Manrope', sans-serif;
        font-size: 14px;
        font-style: normal;
        line-height: normal;
        padding: .5rem 0;

        &.no-meals,
        &.summary {
            width: 100%;
        }

        &:last-child {
            padding-bottom: 0;
        }
    }
}

.block-delivery-date {
    flex-direction: column;
    font-family: 'Manrope', sans-serif;
    font-size: 14px;
    font-style: normal;
    line-height: normal;

    & > div {
        display: flex;
        align-items: center;
    }
}

.btn-cancel,
.btn-add-calendar {
    display: inline-flex;
    margin-left: .5rem;
    cursor: pointer;
    transition-duration: .4s;
    text-decoration: none;
    font-weight: 700;
    letter-spacing: normal;
    position: relative;
    color: #685BC7;
    font-family: 'Manrope', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;

    &:after {
        position: absolute;
        content: '';
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background: #685BC7;
        transition-duration: .4s;
    }

}

.btn-main-app {
    max-width: 400px!important;
    height: 50px !important; 
}

.row-btn-cancel {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1.5rem auto;
    max-width: 400px;
    border-radius: 10px;
    height: 50px !important;  
    transition-duration: .4s; 
    border: 2px solid transparent; 

    .btn-cancel {
        font-size: 16px;
    }

    &:hover {            
        border: 2px solid #685bc7;
    }

}

.block-orders-search-bg {
    padding: 2rem 0 1rem;    
    border-bottom: 2px solid #E1E6EF;
    background: #F1F3F9;
    position: relative;
    margin-top: 3rem;

    &:after {
        position: absolute;
        top: -12px;
        content: '';
        left: 0;
        width: 100%;
        height: 12px;
        background-size: cover;
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" height="12" viewBox="0 0 375 12" fill="none"><path d="M0 2.47254C3.75329 2.04282 7.51921 1.62574 11.2725 1.18338C14.2802 0.829488 17.2752 0.374489 20.2829 0.109073C22.0269 -0.0425935 23.8087 -0.0173158 25.5653 0.0711562C29.3439 0.2481 33.1098 0.652544 36.8757 0.728377C42.0191 0.829488 47.1751 0.703099 52.3185 0.703099C57.5377 0.703099 62.7443 0.69046 67.9635 0.766293C70.8196 0.816849 73.6756 1.03171 76.5316 1.19601C80.2976 1.41088 84.0635 1.58782 87.8294 1.90379C91.0646 2.16921 94.2871 2.6874 97.5222 2.96545C100.075 3.18032 102.628 3.24351 105.193 3.3067C111.499 3.44573 117.805 3.61004 124.111 3.66059C129.924 3.69851 135.738 3.66059 141.551 3.55948C144.457 3.50893 147.351 3.09184 150.258 3.01601C155.085 2.90226 159.925 2.87698 164.765 2.94018C167.798 2.97809 170.819 3.19295 173.852 3.35726C178.035 3.58476 182.218 3.93865 186.401 4.06504C188.953 4.14087 191.506 3.81226 194.059 3.79962C199.051 3.77434 204.042 3.86281 209.034 3.88809C210.942 3.88809 212.838 3.96392 214.746 3.86281C218.676 3.66059 222.657 2.83907 226.511 3.25615C230.871 3.72379 235.067 3.16768 239.326 2.87698C244.381 2.52309 249.448 2.2956 254.503 1.92907C257.738 1.68893 260.961 1.13282 264.209 0.993793C266.306 0.905321 268.417 1.41088 270.527 1.49935C273.206 1.6131 275.885 1.56254 278.565 1.60046C284.984 1.70157 291.404 1.79004 297.824 1.91643C301.362 1.99226 304.913 2.19448 308.452 2.2324C312.799 2.28296 317.134 2.11865 321.481 2.2324C322.884 2.27032 324.261 3.02865 325.677 3.21823C326.321 3.3067 327.029 2.76323 327.724 2.56101C328.255 2.40934 328.836 2.19448 329.354 2.25768C330.226 2.35879 331.047 2.78851 331.919 2.86434C334.586 3.10448 337.265 3.25615 339.944 3.42045C340.336 3.44573 340.816 3.52156 341.107 3.33198C343.647 1.80268 346.402 2.4599 349.093 2.44726C353.163 2.42198 357.219 2.20712 361.289 2.28296C364.89 2.34615 368.492 2.72532 372.093 2.9149C373.054 2.96545 374.027 2.86434 375 2.83907V11.8H0V2.47254Z" fill="%23F1F3F9"/></svg>');
    }

    .form-search {
        display: flex;
        gap: 0 1rem;
        align-items: flex-start;
        justify-content: space-between;

        input {
            border-radius: 10px;
            border: 2px solid #E1E6EF;
            background: #FFF;
            height: 50px;
            padding: 10px 16px;
            min-height: 50px;
        }

        button {
            display: flex;
            width: 72px;
            height: 50px;
            padding: 10px 16px;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border-radius: 10px;
            background: #685BC7;
            border: 2px solid #685BC7;
            transition-duration: .4s;
            
            svg {
                fill: #fff;
                transition-duration: .3s;
            }

            &:hover {
                background:  none;
                svg {
                    fill: #685BC7;
                }
            }
        }
    }
}

.block-orders-res-bg {
    padding: 2rem 0;
    margin-bottom: 50px;
}

.orders-search {
    p {
        color: #1D2433;
        font-family: 'Manrope', sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        padding: 1rem 0 .5rem;
    }
}
.row-loader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
    background-color: rgba(250,250,250, 0.4);
    overflow: hidden;
    margin: 0!important;
}
.main-meals {
    max-width: 600px;
    width: 100%;
    margin: auto; 
}
.products-row {
    width: 100%;
    gap: 2rem 1.5rem;
    display: flex;
    flex-wrap: wrap;

    .product-item {
        width: calc(33.333% - 1.5rem);

        @media (max-width: 500px) {
            width: calc(50% - 1.5rem);
        }
    }
}

.block-page-title {

    &.empty {
        padding-bottom: 0;        
    }

    h2 {
        font-size: clamp(26px, 0.0333333333 * 100vw, 30px);
    }
}

.sort-wrap {
    padding: 2em 5em;

    h4 {
        margin-bottom: 20px;
    }

    ul {
        padding: 0;
        margin: 0;

        li {
            padding-bottom: 15px;

            label {
                padding-left: 20px;
            }
        }
    }
}

.block-delivery-data .v-form {
    .v-selection-control {
        min-width: 150px;
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;

        &--inline .v-label {
            padding-left: 15px;
            margin-top: 0;
        }

        &__wrapper {
            margin: 0;

            .v-selection-control__input {
                margin-left: 0;
            }

            input {
                margin: 0;
                height: 20px;
                opacity: 0!important;
            }
        }
    }
}

</style>